const SANITIZED_ATTR_PREFIX = 'data-sanitized-';
const SANITIZED_ATTR_PREFIX_REGEX = new RegExp(`^${SANITIZED_ATTR_PREFIX}`);
const VALID_ATTR_NAME_SELECTOR_STRING = '([0-9A-Za-zÀ-ÖØ-öø-ÿ._:\\-]+)';
const ALPHANUMERIC_REGEX = new RegExp('^[a-zA-Z0-9]+$');
const ENCODED_TAG_NAME_ATTR = 'data-encoded-tag-name';
const ENCODED_TAG_VALUE_ATTR = 'data-encoded-tag-value';
const ENCODED_ELEMENT_TAG = 'a';
const ENCODED_ATTR_PREFIX = 'data-encoded-attr-';
const ENCODED_PREFIX_REGEX = new RegExp(`^data-encoded-.+`);
const ENCODED_ATTR_NAME_SELECTOR_REGEX = new RegExp(`^${ENCODED_ATTR_PREFIX}${VALID_ATTR_NAME_SELECTOR_STRING}$`);

export { ALPHANUMERIC_REGEX, ENCODED_ATTR_NAME_SELECTOR_REGEX, ENCODED_ATTR_PREFIX, ENCODED_ELEMENT_TAG, ENCODED_PREFIX_REGEX, ENCODED_TAG_NAME_ATTR, ENCODED_TAG_VALUE_ATTR, SANITIZED_ATTR_PREFIX, SANITIZED_ATTR_PREFIX_REGEX };
